import React from "react";
import SysEventsList from "../cimponent/SysEventsList"; 

const SysEventsListContainer = () => (<SysEventsList />)

export default SysEventsListContainer;